//
//
//
//
//
//
//
//

import Config from "../Config/config";
export default {
  name: "home",
  data() {
    return {
      token: "",
      title: "首页",
      popup: false,
      card: [],
      head_portrait: "./../../static/img/user.jpg",
      name: "",
      card_no: "",
      card_balance: "",
      integral: "",
      card_id: "",
      f:[],
    };
  },
  methods: {
    title_right: function () {
      this.popup = true;
      this.$HTTP.HttpPost("/Member/Card/getMemberCardList", {}).then((data) => {
        this.card = data.data.data;
      });
    },
    replace_card: function (id) {
      this.$vux.confirm.show({
        title: "是否gou会员卡",
        onConfirm: () => {
          this.$HTTP
            .HttpPost("/Member/Card/updateMembershipCard", { id: id })
            .then((data) => {
              if (data.data.code === 200) {
                this.init();
                this.popup = false;
              }
            });
        },
      });
    },
    goPath(path) {
      const query = {};
      switch (path) {
        case "youhuiquan":
          // query.token = sessionStorage.getItem("token");
          break;
        case "xiaofeijilu":
          if (this.card_id === "") {
            return;
          }
          query.id = this.card_id;
          break;
        case "shangcheng":
          location.href =
            "https://mall.hfbsoftware.com/#/home?token=" +
            sessionStorage.getItem("token");
          break;
      }
      console.log(path);
      if (path != "shangcheng")
        this.$router.push({
          path: `/${path}`,
          query,
        });
    },

    init() {
      this.$HTTP.HttpPost("/Member/Index/getCardInfo", {}).then((data) => {
        const res = data.data.data;
        this.getInfo(res);
      });
    },
    getInfo(data) {
      this.card_id = data.id;
      this.card_no = data.card_no;
      this.card_balance = data.card_balance;
      this.integral = data.integral;
      this.name = data.name;
      this.head_portrait = data.head_portrait;
      let f1 = data.member_auth1;
      // this.f1.push({
      //   id: 15,
      //   name: "股东分红",
      //   icon:
      //     "https://hfb.oss-cn-hangzhou.aliyuncs.com/membericon/activity.png",
      //     path:'shareholder',
      // },{
      //    id: 16,
      //   name: "股东分销",
      //   icon:
      //     "https://hfb.oss-cn-hangzhou.aliyuncs.com/membericon/activity.png",
      //     path:'fenxiao',
      // });
      let f2 = data.member_auth2;
      this.f = f1.concat(f2)
      let cardInfo = JSON.stringify(data);
      sessionStorage.setItem("cardInfo", cardInfo);

      // this.f1.push({
      //   id: 3,
      //   icon: "https://hfb.oss-cn-hangzhou.aliyuncs.com/membericon/project.png",
      //   name: "揽客",
      //   path: "marketingList"
      // });
    },
    getIntegral() {
      this.$HTTP.HttpPost("/member/Index/getIntegral", {}).then((data) => {
        const res = data.data.data;
        this.integral = res.integral;
        this.card_balance = res.card_balance;
      });
    },
    getUrlCode(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    getCardInfo() {
      if (!sessionStorage.getItem("cardInfo")) {
        this.init();
      } else {
        const data = JSON.parse(sessionStorage.getItem("cardInfo"));
        this.getInfo(data);
      }
      this.getIntegral();
    },
    getOssPath() {
      this.$HTTP.HttpPost("/member/Common/getOssPath").then((res) => {
        sessionStorage.setItem("ossPath", res.data);
      });
    },
  },
  created() {
    // const code = this.getUrlCode("code");
    // // let id = this.getUrlCode('id')
    // // let hid = this.getUrlCode('hid')
    // // let market = {
    // //     id:id,
    // //     hid:hid,
    // //   }
    // // if(id && hid){
    // //   let str = JSON.stringify(market)
    // //   sessionStorage.setItem('market',str)
    // // }
    // const token = sessionStorage.getItem("token");
    // if (code && !token) {
    //   const code = this.getUrlCode("code");
    //   this.$api.login(code).then((res) => {
    //     this.getCardInfo();
    //     console.log(sessionStorage.getItem("token"));
    //     this.getOssPath();
    //     if (res === 1 && Config.mode === "pro") {
    //       window.location.replace("https://h5.hfbsoftware.com/#/");
    //     }
    //     if (res === 1 && Config.mode === "dev") {
    //       window.location.replace("http://192.168.31.134:8000/");
    //     }
    //   });
    // }
    // if (!token & !code) {
    //   console.log(location.href);
    //   this.$api.getAppid(location.href);
    // }
  },
  mounted() {
    // if (sessionStorage.getItem("token")) {
    //   console.log(sessionStorage.getItem("token"));
    //   this.getCardInfo();
    //   this.getOssPath();
    // }
  },
};



// WEBPACK FOOTER //
// ./src/components/home.vue